/* eslint-disable camelcase */

import type { TableResult } from "@tanstack/react-table";

import sharedConstants from "@lib/shared_constants.json";

const {
  INTERNAL_USER_GROUP: { PROPERTY },
} = sharedConstants;

type ValueOf<T> = T[keyof T];

// list of internal group properties
export type Property = ValueOf<typeof PROPERTY>;

export interface AppSettingsV2InternalUserGroupsInternalUserGroupsParams {
  /** the unique identifier for the current app group */
  appGroupId: string;
  /** the query object containing all the filters */
  query?: Partial<Record<string, string | string[]>>;
  /** the number of records to return per page */
  limit?: number;
  /** the direction in which to sort */
  sortdir?: -1 | 1;
  /** the index for the first record in the set among the entire response */
  start?: number;
}

// the list of properties, with information about if it's applied to the internal user group or not
type InternalUserGroupPropertyData = {
  [key in Property]?: { is_enabled: boolean; is_default?: boolean };
};

export interface InternalUserGroup {
  /** unique id for the internal user group */
  id: string;
  /** human readable name for the internal user group */
  name: string;
  /** property information */
  property_data: InternalUserGroupPropertyData;
  /** list of territory strings that are applied to the internal user group */
  territory_ids: string[];
}

export type AppSettingsV2InternalUserGroupsInternalUserGroupsResult = TableResult<InternalUserGroup>;
